import { useEffect } from 'react';
import { validatorInstance } from '@src/scenario-editor/validator/Validator';
import type { ReactFlowInstance } from 'reactflow';
import type { CustomNode, CustomNodeData, ValidationResult } from '@src/components/custom-nodes/types';

export const useNodesValidation = (reactFlowInstance: ReactFlowInstance<ReactFlowInstance, unknown> | undefined, nodes: CustomNode[]) => {
  const { setNodes } = reactFlowInstance ?? {};

  useEffect(() => {
    if (!reactFlowInstance) {
      return;
    }

    const validationResults = nodes.map((node) => {
      const nodeData = node.data as CustomNodeData;
      let validationResult = null;

      if (validatorInstance.isRuleImplemented(`${nodeData?.nodeType ?? ''}:${node?.id}`)) {
        validationResult = validatorInstance.validate(`${nodeData?.nodeType ?? ''}:${node?.id}`, nodeData)
      } else if (validatorInstance.isRuleImplemented(nodeData?.nodeType ?? '')) {
        validationResult = validatorInstance.validate(nodeData.nodeType ?? '', nodeData);
      }

      return validationResult;
    });

    if (nodes.map((node) =>
      (node.data as CustomNodeData).validation?.success ?? 'true').join(',')
        === validationResults.map(res => res?.success ?? 'true').join(',')) {
      return;
    }

    setNodes!(() => {
      return nodes.map((node, index) => {
        (node.data as CustomNodeData).validation = validationResults[index] as ValidationResult;
        return node;
      });
    });

  }, [reactFlowInstance, nodes]);
}
